import { FilterMatchMode } from 'primereact/api';

export interface PaginatedResult<T> {
  data: T[];

  totalCount: number;
}

export interface PaginationOrder {
  isAscending: boolean;

  orderColumn: string;
}

export interface PaginationPage {
  index: number;

  size: number;
}

export interface PaginationParams {
  order: PaginationOrder;

  page: PaginationPage;
}

export interface DateFilters {
  startDate: string;
  endDate: string;
}

export interface PaginationWithDateFilters {
  filters: DateFilters;

  paginationParams: PaginationParams;
}

export interface PaginatorState {
  currentPage: number;
  totalPages: number;
  rows: number;
  showRowsPerPageDropdown?: boolean;
}

export enum SearchMode {
  STARTS_WITH = 'STARTS_WITH',
  CONTAINS = 'CONTAINS',
  EQUALS = 'EQUALS',
  IN = 'IN',
  BETWEEN = 'BETWEEN',
  OVERLAPS = 'OVERLAPS',
}

export interface TableFilter {
  value: any;

  actualValue?: any;

  searchMode: SearchMode;

  matchMode: FilterMatchMode;
}

export interface TableFilterData {
  [key: string]: TableFilter;
}
